import { render, staticRenderFns } from "./Stocktake.vue?vue&type=template&id=7fc63e57&scoped=true&"
import script from "./Stocktake.vue?vue&type=script&lang=js&"
export * from "./Stocktake.vue?vue&type=script&lang=js&"
import style0 from "./Stocktake.vue?vue&type=style&index=0&id=7fc63e57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc63e57",
  null
  
)

export default component.exports